import { render } from "./CharterSurvey.vue?vue&type=template&id=b35674ec"
import script from "./CharterSurvey.vue?vue&type=script&lang=js"
export * from "./CharterSurvey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__